import { STREAK_MISSIONS } from '../constants/streakMission';

export interface IStreakMissionProps {
  images: string[];
  maxStreak: number;
}

export const isStreakMission = (backendId?: string): backendId is string =>
  Boolean(backendId && backendId in STREAK_MISSIONS);

export const getStreakMission = (
  backendId: string
): IStreakMissionProps | null => STREAK_MISSIONS[backendId] ?? null;
